import React, { Component } from 'react';
import DataTableWithServerSizePagination from '../../../../components/DataTable/DataTableWithServerSidePagination';
import SimpleMenu from '../../../../components/Menu/SimpleMenu';
import MoreVert from '@material-ui/icons/MoreVert'
import { connect } from 'react-redux';
import history from '../../../../history';
import * as wbsActions from '../../../../store/actions/wbs';
import DataExportContainer from '../../../../containers/DataExport/DataExportContainer';
import vendorTypes from '../../../../constants/vendorTypes';
import AutoSelect from '../../../../components/Input/AutoSelectWithDataOnChange';

const vendorTypeSuggestions = vendorTypes.map((vendorType, index) => {
    return {
        label: vendorType,
        value: index
    }
})
const defaultColumns = [
    {
        header: "WBS ID",
        dataProperty: 'id',
        width: 80,
        isVisible: true,
    },
    {
        header: "Activity Name",
        dataProperty: 'activityName',
        width: 300,
        isVisible: true,
    },    
    {
        header: 'Care cost center',
        dataProperty: 'careCostCenter',
        width: 120,
        isVisible: true
    },
    {
        header: "cProject",
        dataProperty: 'cProject',
        width: 60,
        isVisible: true,
    },
    {
        header: "Cost type",
        dataProperty: 'costType',
        width: 60,
        isVisible: true,  
    },
    {
        header: "cwbs",
        dataProperty: 'cwbs',
        width: 60,
        isVisible: true,  
    },
    {
        header: "Description",
        dataProperty: 'description',
        width: 60,
        isVisible: true,  
    },
    {
        header: "PO Location",
        dataProperty: 'poLocation',
        width: 120,
        isVisible: true,
    },
    {
        header: 'Vendor Type',
        dataProperty: 'vendorType',
        width: 80,
        isVisible: true
    },
    {
        header: "pocc",
        dataProperty: 'pocc',
        width: 60,
        isVisible: true,
    },
    {
        header: "powbs",
        dataProperty: 'powbs',
        width: 60,
        isVisible: true,
    },
]

const mapStateToProps = (state) => {
    const columns = state.wbs.columns && state.wbs.columns.length !== 0 ? state.wbs.columns : defaultColumns;
    let wbses = [];
    let inactive = {};
    if (state.wbs.wbses && state.wbs.wbses.items) {
        wbses = state.wbs.wbses.items
        inactive = state.wbs.wbses.inactiveMap
    }
    return {
        tableState: state.table.parsedFilters,
        columns: columns,
        loading: state.wbs.loading,
        wbses: wbses,
        inactive: inactive,
        currentPage: state.wbs.wbses && state.wbs.wbses.currentPage ? state.wbs.wbses.currentPage : 1,
        count: state.wbs.wbses && state.wbs.wbses.itemsCount ? state.wbs.wbses.itemsCount : 0,
    }
};
  
  const mapDispatchToProps = (dispatch) => ({
      loadView: (payload) => {
        dispatch(wbsActions.getWbsListStarted({params: payload.queryParameters}));
        dispatch(wbsActions.getWbsColumnsStarted(payload))
      },
      updateColumns: (payload) => {
        dispatch(wbsActions.updateWbsColumnsStarted(payload));
      },
      getColumns: (payload) => {
        dispatch(wbsActions.getWbsColumnsStarted(payload))
      },
      getActivities: (payload) => {
          dispatch(wbsActions.getWbsListStarted(payload))
      }
  });

class WbsViewer extends Component {

    componentDidMount() {
        const tableState = this.props.tableState[this.getTableName()];
        if (tableState) {
            this.props.loadView({
                queryParameters: tableState,
            });
        } else {
            this.props.loadView({
                wait: false
            });
        }
    }
    handleEditClick(data) {
        history.push(`/masterdata/viewallwbses/${data.id}`);
    }

    onFetchData = (data, wait) => {
        const queryParameters = data;
        this.props.getActivities({params: queryParameters, wait: wait});
    }

    onColumnOrderChanged = (columns) => {
        const payload = JSON.stringify(columns);
        this.props.updateColumns({columns: payload});
    }

    onColumnVisibilityChanged = (newColumns) => {
        const payload = JSON.stringify(newColumns);
        this.props.updateColumns({columns: payload});
    }
    getTableName = () => {
        return "wbs";
    }
    createActionMenu = (data) => {
        return (
            <SimpleMenu 
                icon={MoreVert}
                items={
                    [
                        {onClick: this.handleEditClick, label: 'Edit'}
                    ]
                }
                rowData={data}
            />
        )
    }
    render() {
        return (
            <React.Fragment> 
                <div style={{marginRight: 48, marginTop: 32}}>
                    <DataExportContainer url="api/export/wbs"/>
                    <DataTableWithServerSizePagination
                        sortable
                        general={{selectionEnabled: true, canSelectRowProperty: "canSelect", selectionColumnHeader: "Inactive"}}
                        tableName={this.getTableName()}
                        selected={this.props.inactive}
                        minWidth={980}
                        customColumnsWidthEnabled={true}
                        loading={this.props.loading}
                        count={this.props.count}
                        columns={this.props.columns}
                        onFetchData={this.onFetchData}
                        data={this.props.wbses}   
                        actionMenu={this.createActionMenu}
                        onColumnsOrderChanged={this.onColumnOrderChanged}
                        onColumnVisibilityChanged={this.onColumnVisibilityChanged}
                        currentPage={this.props.currentPage}
                        customFilters={{
                            vendorType: (filterValue, onChange) => {
                                return (
                                    <AutoSelect
                                        isClearable={true}
                                        additionalData="vendorType"
                                        label="Vendor Type"
                                        small
                                        width="100%"
                                        minWidth={100}
                                        suggestions={vendorTypeSuggestions}
                                        value={filterValue}
                                        handleChangeSingle={onChange}
                                    />
                                )
                            },
                        }
                    }
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WbsViewer);